<template>
  <RouterView />
</template>

<script>

import { RouterView } from 'vue-router';
import api from './api/api';

export default {
  name: 'App',
  components: {
    // NavBarCima,
    RouterView
  },
  methods: {},
  computed: {},
  mounted() {
    return [
      api.carregaConfig().then(resp => { this.$store.commit('setConfig', resp); 
      }),
      // api.tipoChamadoListarSub().then(resp => { this.$store.commit('setTpListarSub', resp); }),
      // api.tipoChamadoExisteSub().then(resp => { this.$store.commit('setTpExisteSub', resp); })

    ]
  }

}
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
}

:root {
  --tamanho: 10px;
}
</style>